import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { store } from '../store/store';
import { navigate } from '../store/navigationSlice';
import { userLogout, userSigninRedirect } from '../context/AuthProvider';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const isDashboard = config.url?.includes('dashboard');
    if (isDashboard) {
      try {
        const token = store.getState().auth.accessToken;
        config.headers.Authorization = `Bearer ${token}`;
      } catch (e) {
        console.error(e);
        Promise.reject(e);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          userLogout();
          await new Promise((resolve) => setTimeout(resolve, 1000));
          userSigninRedirect();
          break;
        case 403:
          store.dispatch(navigate('error-auth'));
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
